var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2234 4.23904L0.857422 9.33268H4.57171L7.42885 5.99935L8.85742 7.66602L10.7146 5.49935L9.6343 4.23904C8.47503 2.88656 6.38267 2.88656 5.2234 4.23904Z",
    fill: "#0DA14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0618 11.427L15.4277 6.33333H11.7134L8.85631 9.66667L7.42774 8L5.57059 10.1667L6.65086 11.427C7.81013 12.7795 9.90248 12.7795 11.0618 11.427Z",
    fill: "#0DA14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cedd3dcee3767411a328db8005cd4ef9.svg";
export { ForwardRef as ReactComponent };